import axios from "@/lib/axios";

class ProductActivationService {
  constructor() {
    this.api = axios;
  }

  async getProductActivations() {
    const { data } = await this.api.get(
      "/merchant-product-registration-activations",
    );

    return data;
  }

  async getProductActivation(id) {
    const { data } = await this.api.get(
      `/merchant-product-registration-activations/${id}`,
    );

    return data;
  }

  async deleteActivation(id) {
    const response = await this.api.delete(
      `/merchant-product-registration-activations/${id}`,
    );

    return response;
  }

  async createActivation(data) {
    const response = await this.api.post(
      "/merchant-product-registration-activations",
      data,
    );

    return response;
  }

  async updateActivation(data) {
    const response = await this.api.put(
      `/merchant-product-registration-activations`,
      data,
    );

    return response;
  }

  async downloadQRCodesZip() {
    const response = await this.api.get(
      "/merchant-product-registration-activations/zip",
      {
        responseType: "blob",
      },
    );

    return response;
  }
}

export default new ProductActivationService();
